import { useState } from "react";
import { TableLoader } from "../../../components/Loader";
import { AddIcon, PaperClip } from "../../../assets/icons";
import { GetAccess } from "../../../utils/RolesandAccess";
import UseGetData from "../../../hooks/useFetchData";
import Pagination from "../../../utils/Pagination";
import CreateorUpdate from "./from";
import useFetchMetaData from "../../../hooks/useFetchMetaData";
import ViewMore from "./ViewMore";

function VendorManagement() {
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const [showMyMenu, setShowMyMenu] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenu(false);
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);

  const { data, getData, totalCount, isLoading } = UseGetData({
    url: "/Vendor-Management/get_all",
    page: pageIndex,
    pageCount: dataCount,
  });
  const { metaData } = useFetchMetaData({ value: "vender_type" });

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Vendor Management
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-210px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th className={`text-center px-5 py-4 ${header.width}`}>
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(9)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center text-gray-900 py-1 w-[10%]`}
                        >
                          {data.serial_number || "#"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[45%]`}
                        >
                          {data?.vendor_name || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[20%]`}
                        >
                          {data?.vendor_type || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[20%] flex justify-center items-center`}
                        >
                          {data?.document_type.length > 0 && <PaperClip />}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore
                              onClose={handleOnCloseMenu}
                              visible={showMyMenu}
                              data={data}
                              fetcher={getData}
                              vendorList={metaData}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
        <Pagination
          total={totalCount}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          dataCount={dataCount}
          setDataCount={setDataCount}
        />
      </div>
      <CreateorUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        refreshData={getData}
        vendorList={metaData}
      />
    </>
  );
}

export default VendorManagement;

const header = [
  {
    headone: "SI. No",
    width: "w-[10%]",
  },
  {
    headone: "Name",
    width: "w-[45%]",
  },
  {
    headone: "Type",
    width: "w-[20%]",
  },
  {
    headone: "Doc",
    width: "w-[20%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
